import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Navbar from './Navbar'

const ResultTwo = () => {
  const [resultData, setResultData] = useState(null)

  useEffect(() => {
    axios
      .get('https://aimuseumbackend.teslabird.com/api/cd/user-result/', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access')}`,
        },
      })
      .then((res) => setResultData(res.data))

      .catch((err) => console.error('Failed to fetch result', err))
  }, [])
  console.log('Result:', resultData)

  const getScoreInterpretation = (score) => {
    if (score >= 0 && score <= 13) return 'Very low resilience'
    if (score >= 14 && score <= 20) return 'Low resilience'
    if (score >= 21 && score <= 30) return 'Moderate resilience'
    if (score >= 31 && score <= 40) return 'High resilience'
    return 'Score out of range'
  }

  if (!resultData) {
    return <div className='text-center mt-5'>Loading...</div>
  }

  return (
    <>
      <Navbar />
      <div className='container-fluid'>
        {/* Header Section */}
        <div className='row'>
          <div className='col-12'>
            <div
              className='mt-3 rounded'
              style={{
                backgroundColor: '#4a6b7c',
                color: 'white',
                padding: '30px 0',
                textAlign: 'center',
              }}
            >
              <div className='conatiner'>
                <h1
                  className='mb-0 fs-2 fw-bold'
                  style={{
                    color: 'white',
                    fontSize: '45px',
                    fontFamily: 'Inter',
                    fontWeight: '600',
                  }}
                >
                  Connor-Davidson Resilience Scale: (CD-RISC-10), 2003 - Results
                </h1>
              </div>
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div className='container mt-3'>
          <div className='row'>
            <div className='col-12'>
              <button
                className='btn btn-link text-decoration-none p-0 text-primary'
                onClick={() => window.history.back()}
                style={{ fontSize: '16px', color: '#2D5272' }}
              >
                <i className='fas fa-chevron-left me-2'></i>Back
              </button>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className='container mt-4'>
          <div className='row justify-content-center'>
            <div className='col-12 col-lg-10'>
              <div
                className='p-4 p-md-5 rounded-3'
                style={{ backgroundColor: '#EAFAEF', minHeight: '600px' }}
              >
                {/* Report Section */}
                <div className='mb-4'>
                  <h4
                    className='mb-3'
                    style={{
                      color: '#2D5272',
                      fontSize: '24px',
                      fontFamily: 'Inter',
                      fontWeight: '600',
                    }}
                  >
                    REPORT:
                  </h4>
                  <ul className='list-unstyled'>
                    <li className='mb-2'>
                      <i
                        className='fas fa-circle me-2'
                        style={{ fontSize: '6px', color: '#666' }}
                      ></i>
                      {getScoreInterpretation(resultData.total_score)}
                    </li>
                  </ul>
                  <p className='text-dark mb-4' style={{ lineHeight: '1.6' }}>
                    Based on your responses, you have few or no symptoms of
                    Psychological distress. This result is not a diagnosis. A
                    doctor or therapist can help you get a diagnosis and/or
                    treatment.
                  </p>
                </div>

                {/* Overall Score Badge */}
                <div className='mb-4'>
                  <span
                    className='badge rounded-pill px-4 py-2 fs-6'
                    style={{
                      backgroundColor: '#c8e6c9',
                      color: '#2e7d32',
                      border: '2px solid #4caf50',
                    }}
                  >
                    Overall Score: {resultData.total_score} / 40
                  </span>
                </div>

                {/* Your Answers Section */}
                <div className='mb-4'>
                  <h5 className='fw-bold text-dark mb-3'>Your Answers</h5>
                  <p className='text-dark mb-3'>
                    Give Answers for each question as Yes (1) or No (0)
                  </p>

                  {/* Answers List */}
                  {/* <div className='mb-4'>
                    {resultData.answers.map((ans, index) => (
                      <div
                        key={ans.question_id}
                        className='mb-2 p-2 rounded'
                        style={{ backgroundColor: 'rgba(255,255,255,0.3)' }}
                      >
                        <div className='row align-items-center'>
                          <div className='col-10 col-md-11'>
                            <span className='text-dark'>
                              {ans.question_text}
                            </span>
                          </div>
                          <div className='col-2 col-md-1 text-end'>
                            <span
                              className={`badge ${
                                ans.answer ? 'bg-success' : 'bg-secondary'
                              }`}
                            >
                              {ans.answer ? 'Yes' : 'No'}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div> */}

                  {/* Total Score Badge */}
                  <span
                    className='badge rounded-pill px-4 py-2 fs-6'
                    style={{
                      backgroundColor: '#c8e6c9',
                      color: '#2e7d32',
                      border: '2px solid #4caf50',
                    }}
                  >
                    Total Score: {resultData.total_score} / 40
                  </span>
                </div>

                {/* About Your Score */}
                <div className='mb-4'>
                  <h5 className='fw-bold text-dark mb-3'>About your score</h5>
                  <p className='text-dark'>
                    Each of your answers has a score of 0, 1, 2, 3, or 4. Not
                    true at all (0), rarely true (1), sometimes true (2), often
                    true (3), and true nearly all of the time (4).
                  </p>
                </div>

                {/* Interpreting Your Total Score */}
                <div className='mb-4'>
                  <h5 className='fw-bold text-dark mb-3'>
                    Interpreting your Total Score
                  </h5>
                  <div className='table-responsive'>
                    <table className='table table-bordered bg-white'>
                      <thead style={{ backgroundColor: '#f8f9fa' }}>
                        <tr>
                          <th className='fw-bold'>Score Range</th>
                          <th className='fw-bold'>Interpretation</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          className={
                            resultData.total_score <= 13 ? 'table-success' : ''
                          }
                        >
                          <td>0-13</td>
                          <td>Very low resilience</td>
                        </tr>
                        <tr
                          className={
                            resultData.total_score >= 14 &&
                            resultData.total_score <= 20
                              ? 'table-warning'
                              : ''
                          }
                        >
                          <td>14-20</td>
                          <td>Low resilience</td>
                        </tr>
                        <tr
                          className={
                            resultData.total_score >= 21 &&
                            resultData.total_score <= 30
                              ? 'table-info'
                              : ''
                          }
                        >
                          <td>21-30</td>
                          <td>Moderate resilience</td>
                        </tr>
                        <tr>
                          <td>31-40</td>
                          <td>High resilience</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Action Buttons */}
                <div className='mb-4'>
                  {/* <div className='d-flex flex-column flex-md-row gap-3'>
                    <button
                      className='btn btn-outline-primary'
                      onClick={handlePrint}
                    >
                      <i className='fas fa-print me-2'></i>Print Results
                    </button>
                    <button
                      className='btn btn-outline-primary'
                      onClick={handleEmail}
                    >
                      <i className='fas fa-envelope me-2'></i>Email Results
                    </button>
                  </div> */}
                  <p className='text-dark mt-3 mb-0'>
                    <strong>Print or email your initial results.</strong>
                  </p>
                </div>

                {/* Footer Information */}
                <div className='mt-5 pt-4 border-top'>
                  <p className='text-muted small mb-2'>
                    <strong>Source:</strong> WHO, GENEVA, 1994: WHO/MNH/PSF/94.8
                  </p>
                  <p className='text-muted small mb-0'>
                    <strong>Please note:</strong> Online screening tools are not
                    diagnostic instruments. You are encouraged to share your
                    results with a physician or healthcare provider.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @media print {
          .btn,
          .navbar {
            display: none !important;
          }
        }

        @media (max-width: 768px) {
          .table-responsive {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  )
}

export default ResultTwo
